var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNnIconFlagsUkDelivery = function SvgNnIconFlagsUkDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nn-icon-flags-UK-delivery_svg__Lager_18",
    "data-name": "Lager 18",
    viewBox: "0 0 50.47 33.81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".nn-icon-flags-UK-delivery_svg__cls-3{fill:#fff}.nn-icon-flags-UK-delivery_svg__cls-4{fill:#f20000}"))), /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-UK-delivery_svg__layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-UK-delivery_svg__g1763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-UK-delivery_svg__rect1764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "nn-icon-flags-UK-delivery_svg__rect1764-2",
    "data-name": "rect1764"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.13.12h50.22v33.56H.13z",
    style: {
      fill: "#0037a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 33.34v33.32H25V33.34zm.25-.25H24.77v33.82h50.46V33.09Z",
    style: {
      fill: "#87888a"
    },
    transform: "translate(-24.77 -33.09)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-UK-delivery_svg__path4640",
    d: "M25 66.66h5.6L75 37.07v-3.73h-5.6L25 62.93Z",
    className: "nn-icon-flags-UK-delivery_svg__cls-3",
    transform: "translate(-24.77 -33.09)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-UK-delivery_svg__path6505",
    d: "M75 66.66h-5.6L25 37.07v-3.73h5.6L75 62.93Z",
    className: "nn-icon-flags-UK-delivery_svg__cls-3",
    transform: "translate(-24.77 -33.09)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-UK-delivery_svg__rect1530",
    d: "M21.07.25h8.33v33.31h-8.33z",
    className: "nn-icon-flags-UK-delivery_svg__cls-3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-UK-delivery_svg__rect2152",
    d: "M.25 11.36h49.97v11.1H.25z",
    className: "nn-icon-flags-UK-delivery_svg__cls-3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-UK-delivery_svg__rect3395",
    d: "M.25 13.58h49.97v6.66H.25z",
    className: "nn-icon-flags-UK-delivery_svg__cls-4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-UK-delivery_svg__rect4017",
    d: "M22.73.25h5v33.31h-5z",
    className: "nn-icon-flags-UK-delivery_svg__cls-4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-UK-delivery_svg__path7127",
    d: "M25 66.66h3.72L45.4 55.55h-3.73Z",
    className: "nn-icon-flags-UK-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-UK-delivery_svg__path8371",
    d: "M54.6 44.45h3.73L75 33.34h-3.74Z",
    className: "nn-icon-flags-UK-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-UK-delivery_svg__path8994",
    d: "M75 66.66v-2.49l-12.95-8.62h-3.72Z",
    className: "nn-icon-flags-UK-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "nn-icon-flags-UK-delivery_svg__path9616",
    d: "M25 33.34v2.49l13 8.62h3.72Z",
    className: "nn-icon-flags-UK-delivery_svg__cls-4",
    transform: "translate(-24.77 -33.09)"
  })))));
};
export default SvgNnIconFlagsUkDelivery;